import { CometChat } from "@cometchat/chat-sdk-javascript";
import defaultAgentAvatar from "./assets/Profile.png";
// const host: string = window.location.host;
// const path: string = window.location.pathname;

let IS_AGENT_MODE: boolean = true;
let IS_NO_CODE: boolean = true;

// Defaults (preview.cometchat.com/)
IS_AGENT_MODE = true;
IS_NO_CODE = true;

// Check route for AI Agents mode
// if (host === "ai-agents.cometchat.com" || host === "localhost:3000") {
//   IS_AGENT_MODE = true;
//   IS_NO_CODE = true; // Change if no-code applies
// }

export { IS_AGENT_MODE, IS_NO_CODE };
